<template>
  <span class="tooltip" @click.stop>
    <span class="tooltip__toggle">?</span>
    <span class="tooltip__box">
      <slot />
    </span>
  </span>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.tooltip {
  $root: &;

  position: relative;
  display: inline-block;
  vertical-align: top;

  &__toggle {
    cursor: pointer;
    border-radius: 50px;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    background: #07070714;
    color: #7a7a7a;
    font-size: 14px;
    font-family: $font-family-title;
    font-weight: 600;
  }

  &__box {
    position: absolute;
    z-index: 5;
    left: 100%;
    top: 50%;
    transform: translateY(-50%) translateX(-5px);
    margin-left: 1em;
    opacity: 0;
    visibility: hidden;
    transition: 0.2s;
    border: 1px solid #333333;
    text-align: left;

    padding: 1.5em;

    background: #333333;
    color: #fff;
    box-shadow: -1px 4px 4px rgba(0, 0, 0, 0.25);
    font-size: 14px;
    font-weight: 500;
    font-family: $font-family-primary;
    text-transform: none;
    line-height: 1.2;

    &:before,
    &:after {
      content: "";
      position: absolute;
      right: 100%;
      top: 50%;
      transform: translateY(-50%);
    }

    &:before {
      border: 8px solid transparent;
      border-left: 0;
      border-right-color: #333333;
    }

    &:after {
      height: 2em;
      width: 1.5em;
    }

    img {
      width: 450px;
      max-width: none;
      background-color: #eee;
      vertical-align: bottom;
    }
  }

  &.m-pad-0 {
    #{$root}__box {
      padding: 0;
    }
  }

  &.m-width-m {
    #{$root}__box {
      width: 20em;
    }
  }

  &:hover {
    #{$root}__box {
      transform: translateY(-50%) translateX(0px);
      opacity: 1;
      visibility: visible;
    }
  }
}
</style>
